import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios'
import { BASE_URL, httpConfig } from './constants'

let Store: any
let userActions: any

export const injectStore = (_store: any, _userActions: any) => {
  Store = _store
  userActions = _userActions
}

export function handleRequest() {
  return (param: AxiosRequestConfig) => {
    const { token } = Store.getState().currentUser
    const conf = {
      ...param,
      baseURL: BASE_URL,
      headers: { ...param.headers },
    }
    if (token) {
      conf.headers = {
        ...conf.headers,
        Authorization: `Bearer ${token}`,
        'x-fs-path': window.location.pathname.slice(1, 3),
      }
    }
    return {
      ...conf,
    }
  }
}

export function handleRequestError() {
  return (error: Error | AxiosError) => Promise.reject(error)
}

export function handleResponse() {
  return (response: AxiosResponse) => response
}

export function handleResponseError(instance: AxiosInstance) {
  return async (error: {
    config: { url: string; _retry: boolean }
    response: {
      status: number
      config: { headers: { Authorization: string } }
    }
  }) => {
    const originalConfig = error.config
    const originalHref = window.location.pathname
    if (originalConfig.url !== '/auth/login/' && error.response) {
      /* eslint no-underscore-dangle: ["error", { "allow": ["_retry"] }] */
      if (error.response.status === 401 && !originalConfig._retry) {
        originalConfig._retry = true

        try {
          const { refreshToken } = Store.getState().currentUser
          const rs = await axios.create(httpConfig).post('/auth/refresh/', {
            refresh: refreshToken,
          })

          const { access, refresh } = rs.data
          error.response.config.headers.Authorization = `Bearer ${access}`
          Store.dispatch(
            userActions.setAuthTokens({
              token: access,
              refreshToken: refresh,
            }),
          )
          return instance(originalConfig)
        } catch (err) {
          if (originalHref !== '/login') {
            Store.dispatch(userActions.logoutWithLocationUser(originalHref))
          }
          return Promise.reject(
            new Error('User login has expired. Please contact the INES Analytics team.'),
          )
        }
      } else if (error.response.status === 403) {
        if (originalHref !== '/login') {
          Store.dispatch(userActions.logoutWithLocationUser(originalHref))
        }
        return Promise.reject(
          new Error('User login has expired. Please contact the INES Analytics team.'),
        )
      }
    }
    return Promise.reject(error)
  }
}
